<template>
    <el-card :class="background(booking)">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div style="text-align: left;">
                    <div class="text-primary" style="font-size: 17px">
                        <div>{{ booking.booking_date }}</div>
                        <strong>{{ booking.route.code }}</strong><strong> - {{ booking.formatted_time }}</strong><br>
                    </div>
                    <div>
                        <el-link style="font-size: 80px;" :href="'/client/current-booking?booking_id=' + booking.id"
                            class="text-primary">{{
                                booking.total_completed_tickets }}</el-link> / <span>{{ booking.data.total_capacity }}</span>
                    </div>

                    <strong v-if="booking.data.boarded_tickets == booking.data.total_capacity">
                        <span class="text-red">(FULLY-BOOKED)</span></strong>
                    <strong v-if="booking.data.boarded_tickets > booking.data.total_capacity"><span
                            class="text-red">(OVERBOOKED)</span></strong>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div class="bold" :class="textClass()">DETAILS</div>
                <strong :class="textClass()">STATUS: {{ $store.state.bookings_status[booking.status] }}</strong><br>
                <strong :class="textClass()">VESSEL - {{ booking.vessel.code }} <span
                        v-if="booking.status == 2">DEPARTED ({{ booking.formatted_departure_time }})</span></strong><br>
                <strong :class="textClass()">CHECKED-IN : {{ booking.data.checked_in_tickets || 0 }} </strong><br>

                <strong :class="textClass()">{{ booking.total_pending_tickets || 0 }} PENDING | {{
                    booking.data.online_tickets_count }} ONLINE TICKETS</strong><br>

                <div style="    font-size: 13px;" :class="textClass()">
                    <span>REG: {{ getCountByType(booking, 0) }}</span>|<span> SEN: {{ getCountByType(booking, 2)
                    }}</span>|<span> STUD: {{ getCountByType(booking, 1) }}</span>|<span> CHD:
                        {{ getCountByType(booking, 3) }}</span>|<span> PWD:
                        {{ getCountByType(booking, 4) }}</span>|
                </div>
                <div style="font-size: 12px;color: red">TOTAL NON-SHOW {{ booking.data.total_non_show_tickets }}</div>        
                <hr>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12">
                <div :class="textClass()">
                    <div class="bold">SUMMARY</div>
                    <span v-for="accom, i in booking.data.accommodations" :key="i">{{ accom.code }} ( {{
                        accom.total_tickets
                        }} / {{ accom.total_capacity }} ) | </span>
                </div>

                <div :class="textClass()" style="padding-top: 5px">
                    <div>VESSEL CAPACITY</div>
                    <span v-for="accom, i in booking.data.accommodations" :key="i">{{ accom.code }} : {{
                        accom.capacity }} <span v-if="accom.total_extra_seats">(+ {{ accom.total_extra_seats }} Extra)</span> | </span>
                </div>

                <div :class="textClass()" style="padding-top: 5px">
                    <div>RESERVED SEATS</div>
                    <span v-for="accom, i in booking.data.accommodations" :key="i">{{ accom.code }} ( {{
                        accom.reserved_tickets }} / {{ accom.total_reserved }} ) | </span>
                </div>

                <div style="padding-top: 5px">
                    <div :class="textClass()">ONLINE ({{ booking.allow_online ?
                        'ENABLED' : 'DISABLED' }})</div>
                </div>
                <hr>

            </div>
            <div class="col-lg-3 col-md-12 col-sm-12">
                <div style="text-align: center;">
                    <el-button size="small" plain type="primary" @click="handleCheckin(booking)"
                        v-if="isAllowed('CHECKIN', 'UPDATE') && (!booking.is_locked || isAllowed('CHECKIN', 'DELETE'))"
                        class="mb-2 btn-block ml-0">CHECKIN</el-button>
                    <el-button size="small" plain type="primary" @click="handleView(booking)"
                        class="mb-2 btn-block ml-0">MANIFEST</el-button>
                    <el-button class="mb-2 btn-block ml-0" size="small" plain type="success"
                        @click="handleShowStatus(booking)"
                        v-if="isAllowed('BOOKINGS', 'UPDATE') && (!booking.is_locked || can_update_locked_bookings)">UPDATE
                        STATUS</el-button>

                    <el-button size="small" @click="handleIssue(booking)" class="mb-2 btn-block ml-0"
                        v-if="isAllowed('ON_BOARD_TICKETS', 'CREATE') && !booking.is_locked && booking.status == 1"><el-link
                            :href="'/client/booking-create-tickets?booking_id=' + booking.id" class="text-primary">ISSUE
                            TICKETS</el-link></el-button>

                    <el-dropdown class="btn-block" v-if="isAllowed('BOOKINGS', 'UPDATE') && (!booking.is_locked)"
                        trigger="click">
                        <el-button type="info" size="small">
                            SETTINGS<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <el-button size="small" plain type="primary" @click="handleChangeVessel(booking)"
                                    class="mb-2 btn-block ml-0" v-if="isAllowed('BOOKINGS', 'UPDATE')">CHANGE
                                    VESSEL</el-button>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <el-button size="small" plain type="primary" @click="handleExtraSeats(booking)"
                                    class="mb-2 btn-block ml-0" v-if="isAllowed('BOOKINGS', 'UPDATE')">EXTRA
                                    SEATS</el-button>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <el-button class="mb-2 btn-block ml-0" size="small" plain type="primary"
                                    @click="handleTransfer(booking)"
                                    v-if="isAllowed('BOOKINGS', 'UPDATE')">TRANSFER</el-button>

                            </el-dropdown-item>

                            <el-dropdown-item>
                                <el-button class="mb-2 btn-block ml-0" size="small" plain type="primary"
                                    @click="handleShowMessages(booking)"
                                    v-if="isAllowed('BOOKINGS', 'UPDATE')">MESSAGES</el-button>

                            </el-dropdown-item>

                            <el-dropdown-item>
                                <el-button class="mb-2 btn-block ml-0" size="small" plain type="primary"
                                    @click="handleShowReservations(booking)"
                                    v-if="isAllowed('BOOKINGS', 'UPDATE')">RESERVATIONS</el-button>

                            </el-dropdown-item>

                            <el-dropdown-item>
                                <el-button class="mb-2 btn-block ml-0" size="small" plain type="primary"
                                    @click="handleAllowOnline(booking)" v-if="isAllowed('BOOKINGS', 'UPDATE')">{{
                                        booking.allow_online ? 'DISABLE ONLINE' : 'ENABLE ONLINE' }}</el-button>

                            </el-dropdown-item>

                            <el-dropdown-item>
                                <el-button size="small" plain type="primary" @click="handleDisable(booking, true)"
                                    class="mb-2 btn-block ml-0"
                                    v-if="isAllowed('BOOKINGS', 'DELETE') && booking.is_active">DISABLE</el-button>
                            </el-dropdown-item>

                            <el-dropdown-item>
                                <el-button size="small" plain type="primary" @click="handleDisable(booking, false)"
                                    class="mb-2 btn-block ml-0"
                                    v-if="isAllowed('BOOKINGS', 'DELETE') && !booking.is_active">ENABLE</el-button>
                            </el-dropdown-item>

                        </el-dropdown-menu>
                    </el-dropdown>

                    <div v-if="booking.is_locked" :class="textClass()">LOCKED</div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>

export default {
    props: ['booking', 'can_update_locked_bookings'],
    data() {
        return {
        };
    },
    created: function () {
    },
    methods: {
        background(booking) {
            let klass = ''

            switch (booking.status) {
                case 0:
                    klass = 'bg-red'
                    break;
                case 2:
                    klass = 'bg-green'
                    break;
                case 3:
                    klass = 'bg-light-gray'
                    break;
            }

            return klass
        },
        handleDisable(booking, disable) {
            this.$emit('handleDisable', disable)
        },
        handleAllowOnline() {
            this.$emit('handleAllowOnline', this.booking)
        },
        handleShowReservations() {
            this.$emit('handleShowReservations', this.booking)
        },
        handleShowMessages() {
            this.$emit('handleShowMessages', this.booking)
        },
        handleTransfer() {
            this.$emit('handleTransfer', this.booking)
        },
        handleExtraSeats() {
            this.$emit('handleExtraSeats', this.booking)
        },
        handleChangeVessel() {
            this.$emit('handleChangeVessel', this.booking)
        },
        handleIssue() {
            this.$emit('handleIssue', this.booking)
        },
        handleShowStatus() {
            this.$emit('handleShowStatus', this.booking)
        },
        handleView() {
            this.$emit('handleView', this.booking)
        },
        handleCheckin() {
            this.$emit('handleCheckin', this.booking)
        },
        getCountByType(booking, type) {
            let total = 0
            booking.grouped_passengers.forEach(passenger => {
                if (type == passenger.type) total = passenger.total
            });
            return total
        },
        isDepartedOrCancelled() {
            return this.booking.status == 0 || this.booking.status == 2
        },
        textClass() {
            return this.isDepartedOrCancelled() ? 'text-white' : 'text-black'
        }
    }
}
</script>
